import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import { firestore, firebase } from '../firebaseConfig';
import { SHOPPING_INTERESTS } from '../config/siteConfig';
import { usePopupManager } from './PopupManager';

const ExitIntentPopup = () => {
  const { isActive, closePopup } = usePopupManager();
  const [email, setEmail] = useState('');
  const [interest, setInterest] = useState(SHOPPING_INTERESTS[0]);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!isActive('exit')) return null;

  const handleClose = () => {
    sessionStorage.setItem('exitPopupShown', '1');
    closePopup('exit');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes('@')) return;
    setLoading(true);
    try {
      await firestore.collection('exitLeads').add({
        email: email.toLowerCase().trim(),
        shoppingInterest: interest,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });

      const existing = await firestore.collection('subscribers')
        .where('email', '==', email.toLowerCase().trim()).get();
      if (existing.empty) {
        await firestore.collection('subscribers').add({
          email: email.toLowerCase().trim(),
          source: 'exit-intent',
          subscribedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      setDone(true);
      sessionStorage.setItem('exitPopupShown', '1');
      setTimeout(() => closePopup('exit'), 1500);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 text-left">
        <button
          type="button"
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
          aria-label="Close"
        >
          <CgClose size={22} />
        </button>
        {done ? (
          <p className="text-center py-6 text-green-600 font-semibold">
            Thank you! We&apos;ll be in touch.
          </p>
        ) : (
          <>
            <h2 className="text-xl font-bold text-gray-900 mb-1">Before you go…</h2>
            <p className="text-sm text-gray-600 mb-5">
              Stay connected with Veth Interiors. Tell us what you&apos;re shopping for.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-amber-500"
                  placeholder="you@example.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Shopping interest</label>
                <select
                  value={interest}
                  onChange={(e) => setInterest(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-3 text-sm outline-none focus:border-amber-500"
                >
                  {SHOPPING_INTERESTS.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-gradient-to-r from-amber-600 to-yellow-600 text-white font-bold rounded-full disabled:opacity-60"
              >
                {loading ? 'Submitting…' : 'Stay Connected'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ExitIntentPopup;
